import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme();

export const LoginPage = () => {
  const navigate = useNavigate();

  const redirectPanel = (path) => {
    navigate(path);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const user = data.get("user");
    const token = data.get("token");
    redirectPanel(`/auth?user=${user}&tokenr=${token}&back=login`);
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            width={"60px"}
            alt="Logo"
            src="https://tapptus.com/static/logo/logo-mini.png"
          />
          <Typography component="h1" variant="h5">
            Plataforma de Reportes
          </Typography>
          <br />
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1 }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="user"
              label="Usuario"
              name="user"
              autoComplete="user"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="token"
              label="Token"
              type="password"
              id="token"
              autoComplete="current-password"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Acceder
            </Button>
          </Box>
          <Typography variant="caption" color="text.secondary" sx={{ mt: 2 }}>
            v{process.env.REACT_APP_VERSION}
          </Typography>
        </Box>
      </Container>
    </ThemeProvider>
  );
};
